import { includes } from "lodash";

export default function linkToOriginalRecord(objectUrl, sourceUrl, landingUrl) {
  return includes(landingUrl, "digitalnz.org/records/")
    ? objectUrl
    : sourceUrl || landingUrl;
}
